import { ConnectionType } from '@/features/print/constants'
import { useForm } from '@/features/settings/components/AddPrinterModal/form'
import { FC, ReactNode } from 'react'
import { FormProvider } from 'react-hook-form'

interface FormProps {
    children: ReactNode
    preferredConnectionType: ConnectionType
}

const Form: FC<FormProps> = ({ children, preferredConnectionType }) => {
    const methods = useForm(preferredConnectionType)

    return <FormProvider {...methods}>{children}</FormProvider>
}

export default Form
